import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusFeedbackHost], [campus-feedback-host], campus-feedback-host',
})
export class FeedbackHostDirective {
  @HostBinding('class')
  defaultClasses = ['block'];
}
